import { useTranslation } from "react-i18next";
import { localeMoment } from "../../helpers";
import {
  CalendarIcon,
  ClockIcon,
  ChevronLeftIcon,
} from "@heroicons/react/solid";
import SessionModel from "../../api/models/SessionModel";
import { useEffect } from "react";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import {
  useLocation,
  useNavigate,
  useParams,
  useRoutes,
} from "react-router-dom";
type Props = {
  session: SessionModel | null;
  onClose?: () => void;
};

export default function SessionInfo({ session, onClose }: Props) {
  const LocalBasePath = "page.sessionInfo";
  const { t, i18n } = useTranslation("", { keyPrefix: LocalBasePath });
  const sessionInfo = (session: SessionModel | any) => {
    if (session?.student) {
      return session?.student;
    }
    return session?.tutor ?? {};
  };
  const location = useLocation();
  return (
    <div className="bg-white h-full">
      <div className="p-4 shadow-sm">
        <div className="flex gap-2 items-center justify-between">
          <div className="text-sm font-medium text-gray-700">
            {t("sessionInfo")}
          </div>
          <div className="ms-3 flex h-7 items-center">
            <button type="button" onClick={onClose}>
              <ChevronLeftIcon className="h-5 w-5 -rotate-90 sm:rtl:rotate-0 sm:ltr:rotate-180" />
            </button>
          </div>
        </div>
      </div>
      <div className="h-full overflow-y-auto overflow-x-hidden  md:mx-0 px-6">
        <div className="w-full flex flex-col">
          <div className="w-full flex flex-col mb-8">
            <div className="mt-6 w-full text-gray-700 text-2xl font-semibold">
              {t("session")} #{session?.session_number}
            </div>
            <div className="w-full  flex  justify-between">
              <div className="flex  items-center">
                <div className="w-6 text-gray-400">{<CalendarIcon />}</div>
                <div className="text-gray-500 text-sm">
                  {localeMoment(session?.date!).format("dddd DD/MM/YYYY")}
                </div>
              </div>
              <div className=" p-1  flex items-center ">
                <div className="w-6 text-gray-400">{<ClockIcon />}</div>
                <div className="text-gray-500 text-sm">
                  {localeMoment(session?.start_time!).format("hh:mm A")}
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 space-x-4 mb-6">
            <UserProfilePictureAvatar
              profilePictureUrl={sessionInfo(session)?.profile_picture_url}
              className="w-14 h-14 flex-shrink-0"
              alt={sessionInfo(session)?.name}
            />
            <div className="font-medium dark:text-white">
              <div>{sessionInfo(session)?.name}</div>
              <div className="text-sm text-gray-500 dark:text-gray-400">
                {!location.pathname.includes("/learner") &&
                  sessionInfo(session)?.account?.email}
              </div>
            </div>
          </div>
          {session?.sessionTelawahName && (
            <div className="w-full  border-b mb-2  border-gray-200 flex flex-col items-start  py-4">
              <div>
                <p className="text-gray-500">{t("reading")}</p>
              </div>
              <div>
                <div className="text-gray-600">
                  <span className="flex justify-start gap-1">
                    <span>
                      <h1>{session?.sessionTelawahName}</h1>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          )}
          {sessionInfo(session)?.sponsorship?.sponsor?.name && (
            <div className="w-full  border-b mb-2  border-gray-200 flex flex-col items-start  py-4">
              <div>
                <p className="text-gray-500">{t("sponsorship")}</p>
              </div>
              <div>
                <div className="text-gray-600">
                  <span className="flex justify-start gap-1">
                    <span>
                      {sessionInfo(session)?.sponsorship.sponsor.name}
                    </span>
                    <span>{t("backSlash")}</span>
                    <span>{sessionInfo(session)?.sponsorship.id}</span>
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
